module.exports = __webpack_public_path__ + "img/let_eatscience14.5badf39.png";